/* BiSell bundle list: tidies tier labels that still show raw placeholders. BiSell fills only the first
   {{quantity}} / {{discount}} of an offer's "Tier label", so a label holding two templates renders as
   "Buy 8, get 20% Buy {{quantity}} and get {{discount}} off!". Such a line is rewritten to "Buy 8 and get 20% off!";
   any other text with a leftover placeholder just loses it. A label written as "{{discount}}%" (the value already
   carries its %) shows "12%%", which is collapsed to "12%". Re-runs whenever BiSell re-renders the widget. */
(() => {
  const PLACEHOLDER = /\{\{\s*(quantity|discount)\s*\}\}/;

  function fixText(node) {
    const text = node.textContent;
    if (!PLACEHOLDER.test(text)) {
      if (text.includes('%%')) node.textContent = text.replace(/%{2,}/g, '%');
      return;
    }
    const qty = text.match(/\b(\d+)\b/);
    const off = text.match(/(\d+(?:\.\d+)?\s?%|\$\s?[\d.,]+)/);
    const isTier = /^\s*buy\b/i.test(text) || node.parentElement?.className.toString().includes('discountText');
    node.textContent =
      isTier && qty && off
        ? `Buy ${qty[1]} and get ${off[1]} off!`
        : text.replace(new RegExp(PLACEHOLDER.source, 'g'), '').replace(/\s{2,}/g, ' ').trim();
  }

  function sweep(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) fixText(node);
  }

  function watch(widget) {
    if (widget.dataset.bkBisellFix) return;
    widget.dataset.bkBisellFix = 'on';
    sweep(widget);
    new MutationObserver(() => sweep(widget)).observe(widget, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    document.querySelectorAll('.bf-widget-bl, bf-upsell-widget').forEach(watch);
  }

  init();
  // Widgets that appear later (app embed loading after the theme, quick views) are picked up too.
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
